import { apiGet, getApiBaseUrl } from './client';

// Fetch worker events from backend (signature preserved)
export async function fetchWorkerEvents({ date, from, to, env = 'memo', options = {} }) {
  console.log('Fetching worker events with params:', { date, from, to, env, options });
  const base = getApiBaseUrl();
  // Defaults for busy environments; can be overridden by caller via options
  const merged = {
    sliceMinutes: 15,
    limit: 5000,
    maxTotalEvents: 100000,
    ...options,
  };

  const params = new URLSearchParams({ date, from, to, env, progress: '1' });
  if (merged.sliceMinutes) params.set('sliceMinutes', String(merged.sliceMinutes));
  if (merged.limit) params.set('limit', String(merged.limit));
  if (merged.maxTotalEvents) params.set('maxTotalEvents', String(merged.maxTotalEvents));
  if (merged.types) params.set('types', String(merged.types));
  if (merged.maxSlices) params.set('maxSlices', String(merged.maxSlices));

  const streamUrl = `${base}/worker-events?${params.toString()}`;

  // Provide a small helper to consume progress via SSE and then fetch final JSON
  function openProgress(onMeta, onProgress, onDone, onError) {
    const es = new EventSource(streamUrl);
    es.addEventListener('meta', (e) => { try { onMeta && onMeta(JSON.parse(e.data)); } catch(_){} });
    es.addEventListener('progress', (e) => { try { onProgress && onProgress(JSON.parse(e.data)); } catch(_){} });
    es.addEventListener('done', (e) => { try { onDone && onDone(JSON.parse(e.data)); } catch(_){} es.close(); });
    es.onerror = (e) => { try { onError && onError(e); } finally { es.close(); } };
    return es;
  }

  async function fetchFinal() {
    // fetch without progress to get the full JSON
    return apiGet('/worker-events', { params: { date, from, to, env, sliceMinutes: merged.sliceMinutes, limit: merged.limit, maxTotalEvents: merged.maxTotalEvents, types: merged.types, maxSlices: merged.maxSlices } });
  }

  return { openProgress, fetchFinal };
}
